// color code for customily
(function () {
  const ROOT_SEL = '.customily_option.accordion-design';

  function contrastText(rgb) {
    const m = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(rgb || '');
    if (!m) return '#fff';
    const r = +m[1], g = +m[2], b = +m[3];
    const L = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    return L > 0.6 ? '#111' : '#fff';
  }

  function init(root) {
    if (!root || root.dataset.ropeReady) return;
    root.dataset.ropeReady = '1';

    const content = root.querySelector('.cl-option-content');
    if (!content) return;

    /* Rope bar */
    const bar = document.createElement('div');
    bar.className = 'rope-bar';
    bar.innerHTML = `
      <div class="rope-left">
        <span class="rope-value">Select Color</span>
      </div>
      <button type="button" class="rope-toggle" aria-expanded="false">
        <img alt="eyedropper tool" src="https://cdn.shopify.com/s/files/1/0759/0582/7052/files/Frame_30.png?v=1751538761" width="15" height="15">
        Change Color
      </button>
    `;
    root.insertBefore(bar, content);

    const btn = bar.querySelector('.rope-toggle');
    const valueEl = bar.querySelector('.rope-value');

    function applyFromChecked() {
      /* 🔥 ONLY truth: checked radio */
      const checked = root.querySelector('input[type="radio"]:checked');
      if (!checked) return;

      const label = root.querySelector(`label[for="${checked.id}"]`);
      if (!label) return;

      /* ✅ NAME */
      valueEl.textContent = checked.value || 'Color';

      /* ✅ COLOR (inline bg from label) */
      const bg = label.style.backgroundColor;
      if (bg) {
        const contrast = contrastText(bg);
        bar.style.backgroundColor = bg;
        bar.style.color = contrast;
        bar.style.borderColor =
          contrast === '#111' ? '#ccc' : 'transparent';
      }
    }

    /* Toggle open / close (as-is) */
    btn.addEventListener('click', () => {
      root.classList.toggle('is-open');
      btn.setAttribute(
        'aria-expanded',
        String(root.classList.contains('is-open'))
      );
      applyFromChecked();
    });

    /* Radio change */
    root.addEventListener('change', e => {
      if (e.target.matches('input[type="radio"]')) {
        requestAnimationFrame(applyFromChecked);
      }
    });

    /* Swatch click (Customily async safe) */
    root.addEventListener('click', e => {
      const label = e.target.closest('label');
      if (!label) return;

      const id = label.getAttribute('for');
      const radio = id && document.getElementById(id);
      if (!radio) return;

      setTimeout(applyFromChecked, 0);
    });

    /* Initial paint */
    root.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    applyFromChecked();
  }

  function boot() {
    document.querySelectorAll(ROOT_SEL).forEach(init);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  new MutationObserver(boot).observe(document.body, {
    subtree: true,
    childList: true
  });
})();

window.customilyAccordionDefaults =
  window.customilyAccordionDefaults || {};

const accordionDefaultObserver = new MutationObserver(() => {
  document
    .querySelectorAll(".customily_option.accordion-design")
    .forEach(root => {
      const optId = root.getAttribute("opt-id");
      if (!optId) return;

      // already stored
      if (window.customilyAccordionDefaults[optId]) return;

      const activeLabel = root.querySelector(
        ".customily-swatch label.label-focus"
      );
      if (!activeLabel) return;

      const inputId = activeLabel.getAttribute("for");
      if (!inputId) return;

      const input = root.querySelector(
        `input#${CSS.escape(inputId)}`
      );
      if (!input) return;

      window.customilyAccordionDefaults[optId] = input.value;

      console.log(
        "🎯 Captured accordion default:",
        optId,
        input.value
      );
    });
});

accordionDefaultObserver.observe(document.body, {
  subtree: true,
  childList: true
});

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".reset-suggestion-btn");
  if (!btn) return;

  setTimeout(() => {
    document
      .querySelectorAll(".customily_option.accordion-design")
      .forEach(root => {
        const optId = root.getAttribute("opt-id");
        const defaultColor =
          window.customilyAccordionDefaults?.[optId];

        if (!defaultColor) {
          console.warn(
            "❌ No accordion default stored for",
            optId
          );
          return;
        }

        const radio = root.querySelector(
          `input[type="radio"][value="${CSS.escape(defaultColor)}"]`
        );

        if (!radio) return;

        console.log(
          "🎨 Reset accordion to default:",
          optId,
          defaultColor
        );

        radio.click(); // ✅ true reset
      });
  }, 200);
});




// swatch size

window.addEventListener('customily-options-loaded', function (e) {

   $('#cl_optionsapp .customily_option.category-swatch .swatch-container')
    .find('label, img, .csh-image-container')
    .removeAttr('style');

   $('#cl_optionsapp .customily_option.category-option-class .swatch-container .customily-swatch  label').each(function (){
        $(this).css({ 'height': '', 'min-height': '' , 'max-height':'', 'padding':'' });   
    });

  $('#cl_optionsapp .customily_option.category-swatch .swatch-container label').each(function (){
        $(this).css({  'width': '', 'height': '', 'max-width': '', 'min-height': '' , 'min-width':'', 'max-height':'' });   
    });

     $('.customily_option.liquor-engraving-color input.needsclick.needsfocus').each(function(){
         $(this).next('label').next('span.liq-label-txt').remove();
          var label_txt = $(this).val();
          $(this).next('label').after('<span class="liq-label-txt">' + label_txt + '</span>');
      });

    $('body').on('click', '.customily_option.category-option-class .swatch.customily-swatch', function () {
    setTimeout(function () {
      $('#cl_optionsapp .customily_option.category-swatch .swatch-container label').each(function (){
        $(this).css({  'width': '', 'height': '', 'max-width': '', 'min-height': '' , 'min-width':'', 'max-height':'' });   
    });
     $('#cl_optionsapp .customily_option.category-swatch .swatch-container')
    .find('label, img, .csh-image-container')
    .removeAttr('style');
    }, 50);
});



$('body').on(
  'click change',
  'variant-selects input[type="radio"], variant-selects label.swatch-block',
  function () {
    setTimeout(function () {
      $('#cl_optionsapp .customily_option.category-option-class .swatch-container .customily-swatch  label').each(function (){
        $(this).css({ 'height': '', 'min-height': '' , 'max-height':'', 'padding':'' });   
    });
      // same reset logic jo customily me hai
      $('#cl_optionsapp .customily_option.category-swatch .swatch-container label')
        .each(function () {
          $(this).css({
            width: '',
            height: '',
            'max-width': '',
            'min-height': '',
            'min-width': '',
            'max-height': ''
          });
        });

      $('#cl_optionsapp .customily_option.category-swatch .swatch-container label, #cl_optionsapp img')
        .each(function () {
          $(this).attr('style', '');
        });

    }, 50);

  }
);

});

$('body').on(
  'click change',
  'variant-selects input[type="radio"], variant-selects label.swatch-block',
  function () {
    setTimeout(function () {
      $('.customily_option.liquor-engraving-color input.needsclick.needsfocus').each(function(){
         $(this).next('label').next('span.liq-label-txt').remove();
          var label_txt = $(this).val();
          $(this).next('label').after('<span class="liq-label-txt">' + label_txt + '</span>');
      });

    }, 50);
});


//liquor Engraving color add label code here
$('body').on('click', '.customily_option.liq-engraving-style .swatch.customily-swatch', function () {
    setTimeout(function () {
      $('.customily_option.liquor-engraving-color input.needsclick.needsfocus').each(function(){
         $(this).next('label').next('span.liq-label-txt').remove();
          var label_txt = $(this).val();
          $(this).next('label').after('<span class="liq-label-txt">' + label_txt + '</span>');
      });

    }, 50);
});


//edit option for text code here
window.addEventListener("customily-options-loaded", function () {

  /* =================================================
     HELPERS
  ================================================= */

  function getRelatedFontBlocks(textStyleEl) {
    const blocks = [];
    let next = textStyleEl.nextElementSibling;

    while (next) {
      if (
        next.classList.contains("custom-font-style") ||
        next.classList.contains("font-block-1") ||
        next.classList.contains("font-block-2")
      ) {
        blocks.push(next);
      }

      if (next.classList.contains("text-style")) break;
      next = next.nextElementSibling;
    }

    return blocks;
  }

  function getDependentOptions(textStyleEl) {

  const deps = [];
  let next = textStyleEl.nextElementSibling;

  while (next) {

    // Stop when next text-style
    if (
      next.classList.contains("customily_option") &&
      next.classList.contains("text-style")
    ) {
      break;
    }

    // Collect consecutive dependent blocks
    if (
      next.classList.contains("customily_option") &&
      (
        next.classList.contains("font-dependent-option") ||
        next.classList.contains("custom-design-color")
      )
    ) {
      deps.push(next);
    } else {
     
      break;
    }

    next = next.nextElementSibling;
  }

  return deps;
}


  function hideElements(els) {
    els.forEach(el => el && (el.style.display = "none"));
  }

  function showElements(els) {
    els.forEach(el => el && (el.style.display = ""));
  }

  /* =================================================
     SELECT FONT / COLOR HELPER TEXT
  ================================================= */

  function addSelectFontText() {
  document
    .querySelectorAll(".customily_option.font-dependent-option")
    .forEach(option => {

      const label = option.querySelector("label");
      if (!label) return;

      /* ===============================
         FONT HELPER
      =============================== */
      if (!label.nextElementSibling?.classList.contains("select-font-text")) {
        const fontHelper = document.createElement("div");
        fontHelper.className = "select-font-text";
        fontHelper.innerHTML = `
          <span class="select-font-label">Select your font</span>
          <span class="reset-font-suggestion">
            <span class="reset-icon">⟳</span>
            <span class="reset-text">Reset font</span>
          </span>
        `;
        label.insertAdjacentElement("afterend", fontHelper);
      }

      /* ===============================
         COLOR HELPER (NEW – SAME STYLE)
      =============================== */
      if (
        option.classList.contains("custom-design-color") &&
        !label.parentElement.querySelector(".select-color-text")
      ) {
        const colorHelper = document.createElement("div");
        colorHelper.className = "select-color-text";
        colorHelper.innerHTML = `
          <span class="select-color-label">Select your color</span>
          <span class="reset-color-suggestion">
            <span class="reset-icon">⟳</span>
            <span class="reset-text">Reset color</span>
          </span>
        `;

        const fontText = label.parentElement.querySelector(".select-font-text");
        if (fontText) {
          fontText.insertAdjacentElement("afterend", colorHelper);
        }
      }
    });
}


  /* =================================================
     EDIT / SAVE BUTTON LOGIC (FINAL SAFE VERSION)
  ================================================= */

  function setupEditButtons() {
    document
      .querySelectorAll(".customily_option.text-style")
      .forEach(textStyle => {

        const content = textStyle.querySelector(".cl-option-content");
        if (!content) return;

        const dependentOptions = getDependentOptions(textStyle);

        if (!dependentOptions.length) {
          const oldBtn = content.querySelector(".customily-edit-btn");
          if (oldBtn) oldBtn.remove();
          return;
        }

        if (content.querySelector(".customily-edit-btn")) return;

        const fontBlocks = getRelatedFontBlocks(textStyle);

        const hasColorOption = dependentOptions.some(opt =>
          opt.classList.contains("custom-design-color")
        );

        const hasFontOption = dependentOptions.some(opt =>
          opt.classList.contains("font-dependent-option") &&
          !opt.classList.contains("custom-design-color")
        );

        /* 🔹 DEFAULT (existing behaviour) */
        let editText = "Edit Font";
        let saveText = "Save Font";

        /* 🔹 EXISTING CASE (Font + Color) — DO NOT TOUCH */
        if (hasColorOption && hasFontOption) {
          editText = "Edit Font & Color";
          saveText = "Save Font & Color";
        }

        /* 🔹 NEW CASE (ONLY Color) */
        if (hasColorOption && !hasFontOption) {
          editText = "Edit Color";
          saveText = "Save Color";
        }

        const button = document.createElement("button");
        button.type = "button";
        button.className = "customily-edit-btn";
        button.dataset.open = "false";

        /* ✅ IMPORTANT: preserve color class */
        if (hasColorOption) {
          button.classList.add("edit-text-color-btn");
        }

        button.innerHTML = `
          <span class="edit-icon"></span>
          <span class="edit-text">${editText}</span>
        `;

        button.addEventListener("click", function () {
          const isOpen = button.dataset.open === "true";

          if (!isOpen) {
            showElements(fontBlocks);
            showElements(dependentOptions);
            button.querySelector(".edit-text").innerText = saveText;
            button.dataset.open = "true";
          } else {
            hideElements(fontBlocks);
            hideElements(dependentOptions);
            button.querySelector(".edit-text").innerText = editText;
            button.dataset.open = "false";
          }
        });

        content.appendChild(button);
      });
  }

  /* =================================================
     INITIAL HIDE
  ================================================= */

  function initialHide() {
    document
      .querySelectorAll(".customily_option.text-style")
      .forEach(textStyle => {
        hideElements(getRelatedFontBlocks(textStyle));
        hideElements(getDependentOptions(textStyle));
      });

    addSelectFontText();
  }

  /* =================================================
     OBSERVER
  ================================================= */

  const observer = new MutationObserver(() => {
    setupEditButtons();
    addSelectFontText();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setupEditButtons();
  initialHide();

  /* =================================================
     LAYOUT CHANGE RESET
  ================================================= */

  document.addEventListener("change", function (e) {

  const isLayoutChange = e.target.matches(
  ".customily_option.category-swatch input[type='radio']"
);

const isCategoryChange = e.target.matches(
  ".customily_option.category-option-class input[type='radio']"
);

const isVariantChange = e.target.closest("variant-selects");

if (!isLayoutChange && !isCategoryChange && !isVariantChange) return;

/* 🔒 Close existing panels */
document
  .querySelectorAll(".customily_option.text-style")
  .forEach(textStyle => {
    hideElements(getRelatedFontBlocks(textStyle));
    hideElements(getDependentOptions(textStyle));

    const btn = textStyle
      .querySelector(".cl-option-content .customily-edit-btn");

    if (btn) {
      btn.dataset.open = "false";
    }
  });

/* 🧠 IMPORTANT: Variant change par new DOM ke liye */
if (isVariantChange) {
  setTimeout(() => {
    initialHide();        // 👈🔥 THIS IS THE FIX
    setupEditButtons();  // safety
  }, 50);
}

  document
    .querySelectorAll(".customily_option.text-style")
    .forEach(textStyle => {

      const content = textStyle.querySelector(".cl-option-content");
      const btn = content?.querySelector(".customily-edit-btn");
      const deps = getDependentOptions(textStyle);

      const hasColorOption = deps.some(opt =>
        opt.classList.contains("custom-design-color")
      );

      const hasFontOption = deps.some(opt =>
        opt.classList.contains("font-dependent-option") &&
        !opt.classList.contains("custom-design-color")
      );

      if (btn) {
        btn.querySelector(".edit-text").innerText =
          hasColorOption && hasFontOption
            ? "Edit Font & Color"
            : hasColorOption
            ? "Edit Color"
            : "Edit Font";

        btn.dataset.open = "false";
      }

      // 🔒 Close everything
      hideElements(getRelatedFontBlocks(textStyle));
      hideElements(deps);
    });

  addSelectFontText();
});


});


/* =================================================
   CUSTOMILY – RESET FONT TO SUGGESTION
================================================= */
window.customilyLayoutFontDefaults =
  window.customilyLayoutFontDefaults || {};
window.customilyDefaultValues = window.customilyDefaultValues || {};
function getCurrentLayoutValue() {

  const checked = document.querySelector(
    ".customily_option.category-swatch input[type='radio']:checked"
  );

  if (checked) return checked.value;

  // 🔥 If no layout (Occasion case)
  if (window.currentProductType?.toLowerCase().includes("occasion")) {
    return "occasion-default";
  }

  return null;
}

/* 🔹 Capture default font safely */
function captureDefaultFont(optionEl) {
  const dropdown = optionEl.querySelector(".csh-dropdown-container");
  if (!dropdown) return;

  const vue = dropdown.__vue__ || dropdown.__vueParentComponent;
  if (!vue || !vue.option || !vue.option.value) return;

  const optId = optionEl.getAttribute("opt-id");
  if (!optId) return;

  const layout = getCurrentLayoutValue();
  if (!layout) return;

  window.customilyLayoutFontDefaults[layout] =
    window.customilyLayoutFontDefaults[layout] || {};

  // 🔒 capture ONLY once per layout
  if (!window.customilyLayoutFontDefaults[layout][optId]) {
    window.customilyLayoutFontDefaults[layout][optId] = vue.option.value;
    console.log("📌 Captured default font:", layout, vue.option.value);
  }
}


/* 🔹 Retry capture (Customily async) */
window.addEventListener("customily-options-loaded", function () {
  let tries = 0;
  const interval = setInterval(() => {
    document
      .querySelectorAll(".customily_option.font-dependent-option")
      .forEach(opt => captureDefaultFont(opt));

    tries++;
    if (tries > 15) clearInterval(interval);

  }, 400);

});

/* 🔹 Reset for suggestion click (WITH APPLY) */
document.addEventListener("click", function (e) {
  const resetBtn = e.target.closest(".reset-font-suggestion");
  if (!resetBtn) return;

  const optionEl = resetBtn.closest(".customily_option.font-dependent-option");
  if (!optionEl) return;

  const optId = optionEl.getAttribute("opt-id");
  const layout = getCurrentLayoutValue();
if (!layout) return;

const defaultValue =
  window.customilyLayoutFontDefaults?.[layout]?.[optId];

if (!defaultValue) return;


  const dropdown = optionEl.querySelector(".csh-dropdown-container");
  const vue =
    dropdown.__vue__ ||
    dropdown.__vueParentComponent;

  if (!vue || !vue.option) return;

  /* 1️⃣ Set value */
  vue.option.value = defaultValue;

  /* 2️⃣ FORCE Customily to apply change */
  if (typeof vue.option.apply === "function") {
    vue.option.apply();
  } else if (typeof vue.applyOption === "function") {
    vue.applyOption();
  } else if (typeof vue.$emit === "function") {
    vue.$emit("change");
  }

  /* 3️⃣ Force re-render */
  if (typeof vue.$forceUpdate === "function") {
    vue.$forceUpdate();
  }

  console.log("✅ Font reset + applied to design:", defaultValue);
});

/* =================================================
   RE-CAPTURE DEFAULT FONT ON LAYOUT CHANGE
================================================= */

document.addEventListener("change", function (e) {

  const isLayoutChange = e.target.matches(
    ".customily_option.category-swatch input[type='radio']"
  );

  const isCategoryChange = e.target.matches(
    ".customily_option.category-option-class input[type='radio']"
  );

  if (!isLayoutChange && !isCategoryChange) return;

  // 1️⃣ Clear old defaults
  window.customilyLayoutFontDefaults =
  window.customilyLayoutFontDefaults || {};


  // 2️⃣ Re-capture new defaults after layout/category renders
  let tries = 0;
  const interval = setInterval(() => {
    document
      .querySelectorAll(".customily_option.font-dependent-option")
      .forEach(opt => captureDefaultFont(opt));

    tries++;
    if (tries > 10) clearInterval(interval);
  }, 300);
});



//color reset code here
window.customilyColorDefaults = window.customilyColorDefaults || {};

const colorDefaultObserver = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (!(node instanceof HTMLElement)) return;

      // find any color option inside this node
      const colorOptions = node.matches?.(".customily_option.custom-design-color")
        ? [node]
        : node.querySelectorAll?.(".customily_option.custom-design-color");

      if (!colorOptions) return;

      colorOptions.forEach(optionEl => {
        const optId = optionEl.getAttribute("opt-id");
        if (!optId) return;

        // already captured → skip
        if (window.customilyColorDefaults[optId]) return;

        const activeLabel = optionEl.querySelector(
          ".customily-swatch label.label-focus"
        );
        if (!activeLabel) return;

        const inputId = activeLabel.getAttribute("for");
        if (!inputId) return;

        const input = optionEl.querySelector(
          `input#${CSS.escape(inputId)}`
        );
        if (!input) return;

        window.customilyColorDefaults[optId] = input.value;

        console.log(
          "🎯 Captured TRUE default color (observer):",
          optId,
          input.value
        );
      });
    });
  });
});

colorDefaultObserver.observe(document.body, {
  childList: true,
  subtree: true
});

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".reset-color-suggestion");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const optionEl = btn.closest(".customily_option.custom-design-color");
  if (!optionEl) return;

  const optId = optionEl.getAttribute("opt-id");
  const defaultColor = window.customilyColorDefaults?.[optId];

  if (!defaultColor) {
    console.warn("❌ No stored default color for", optId);
    return;
  }

  const radio = optionEl.querySelector(
    `input[type="radio"][value="${CSS.escape(defaultColor)}"]`
  );

  if (radio) {
    console.log("♻️ Reset color to default:", defaultColor);
    radio.click();
  }
});


// Choose Engraving Color code here

window.customilyColorDefaults = window.customilyColorDefaults || {};

const engravingObserver = new MutationObserver(() => {

  document.querySelectorAll(
    ".customily_option.liquor-engraving-color"
  ).forEach(optionEl => {

    const optId = optionEl.getAttribute("opt-id");
    if (!optId) return;

    // agar already stored hai to skip karo
    if (window.customilyColorDefaults[optId]) return;

    const checked = optionEl.querySelector(
      "input[type='radio']:checked"
    );

    if (!checked) return;

    window.customilyColorDefaults[optId] = checked.value.trim();

    console.log("🥃 Stored engraving default:", checked.value);
  });

});

engravingObserver.observe(document.body, {
  childList: true,
  subtree: true
});


//Reset to suggestion code for text, color and font family

window.addEventListener("customily-options-loaded", function () {

  let layoutDefaults = {};
  let currentLayout = null;
  let userChangedLayout = false;
  

  function getSelectedLayout() {
    return document.querySelector(
      ".customily_option.category-swatch input[type='radio']:checked"
    )?.value || null;
  }

  function getSelectedVariant() {
    return document.querySelector(
      'variant-selects input[type="radio"]:checked'
    )?.value || "default";
  }

  function getLayoutKey() {
    return getSelectedVariant() + "__" + currentLayout;
  }

  function removeResetButton() {
    document.querySelector(".reset-suggestion-btn")?.remove();
  }

  function addResetButton() {

  const container = document.querySelector(".customily_sets-container");
  if (!container) return;

  // 🔥 Check if editable options exist
  const hasTextOption = document.querySelector(".customily_option.text-style");
  const hasColorOption = document.querySelector(".customily_option.custom-design-color");
  const hasEngravingOption = document.querySelector(".customily_option.liquor-engraving-color");

  if (!hasTextOption && !hasColorOption && !hasEngravingOption) {
    removeResetButton();
    return; // ❌ Nothing to reset
  }

  removeResetButton();

  const button = document.createElement("button");
  button.type = "button";
  button.className = "reset-suggestion-btn";
  button.innerHTML = "⟳ Reset to suggestion";

  container.appendChild(button);
}


  /* ---------------- VARIANT CHANGE ---------------- */

  document.addEventListener("change", function (e) {

    if (e.target.matches('variant-selects input[type="radio"]')) {

      removeResetButton();

      setTimeout(() => {

        currentLayout = getSelectedLayout();
        if (!currentLayout) return;

        const layoutKey = getLayoutKey();

       if (!layoutDefaults[layoutKey]) {
      layoutDefaults[layoutKey] = { text: {} };
    }

        document.querySelectorAll(
          ".customily_option.text-style"
        ).forEach(optionEl => {

          const optId = optionEl.getAttribute("opt-id");
          if (!optId) return;

          const input = optionEl.querySelector(
            "input[type='text'], textarea"
          );

          if (!input) return;

          if (layoutDefaults[layoutKey].text[optId] === undefined) {
          layoutDefaults[layoutKey].text[optId] = input.value.trim();
        }

          console.log("🟢 Captured default text:", optId, input.value);
        });

        addResetButton();

      }, 300);
    }
  });

  document.addEventListener("click", function(e) {

  const layoutRadio = e.target.closest(
    '.customily_option.category-swatch input[type="radio"]'
  );

  if (layoutRadio) {
    userChangedLayout = true;
    console.log("👆 User manually clicked layout");
  }

});


document.addEventListener("change", function (e) {

  if (e.target.closest(".customily_option.category-option-class")) {

    removeResetButton();

    setTimeout(() => {

      const selectedLayout = document.querySelector(
        '.customily_option.category-swatch input[type="radio"]:checked'
      );

      if (selectedLayout) {
        addResetButton();
      }

    }, 500); // wait for Customily re-render
  }

});

  /* ---------------- LAYOUT CHANGE ---------------- */

  document.addEventListener("change", function (e) {

    if (
      e.target.matches(
        '.customily_option.category-swatch input[type="radio"]'
      )
    ) {
     
      setTimeout(() => {

        currentLayout = getSelectedLayout();
        if (!currentLayout) return;

        const layoutKey = getLayoutKey();

        if (!layoutDefaults[layoutKey]) {
        layoutDefaults[layoutKey] = { text: {} };
      }

        document.querySelectorAll(
          ".customily_option.text-style"
        ).forEach(optionEl => {

          const optId = optionEl.getAttribute("opt-id");
          if (!optId) return;

          const input = optionEl.querySelector(
            "input[type='text'], textarea"
          );

          if (!input) return;

          if (layoutDefaults[layoutKey].text[optId] === undefined) {
          layoutDefaults[layoutKey].text[optId] = input.value.trim();
        }

          console.log("🟢 Captured default text:", optId, input.value);
        });

        addResetButton();

      }, 200);
    }
  });



  /* ---------------- RESET BUTTON CLICK ---------------- */

  document.addEventListener("click", function (e) {

    if (!e.target.closest(".reset-suggestion-btn")) return;
    if (!currentLayout) return;

    const layoutKey = getLayoutKey();
    if (!layoutDefaults[layoutKey]) return;

    console.log("♻️ Reset triggered for:", layoutKey);


    /* ---------- TEXT RESET ---------- */

    document.querySelectorAll(
      ".customily_option.text-style"
    ).forEach(optionEl => {

      const optId = optionEl.getAttribute("opt-id");
      if (!optId) return;

      const input = optionEl.querySelector(
        "input[type='text'], textarea"
      );
      if (!input) return;

      const defaultVal =
        layoutDefaults[layoutKey]?.text?.[optId];

      if (defaultVal !== undefined) {

        input.value = defaultVal;

        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
        input.dispatchEvent(new Event("blur", { bubbles: true }));

        console.log("✏️ Text reset:", optId);
      }
    });



    /* ---------- COLOR RESET ---------- */

    document.querySelectorAll(
      ".customily_option.custom-design-color"
    ).forEach(optionEl => {

      const optId = optionEl.getAttribute("opt-id");
      if (!optId) return;

      const defaultColor =
        window.customilyColorDefaults?.[optId];

      if (!defaultColor) {
        console.warn("❌ No stored default color for", optId);
        return;
      }

      const radio = optionEl.querySelector(
        `input[type="radio"][value="${CSS.escape(defaultColor)}"]`
      );

      if (radio) {
        radio.click();
        console.log("🎨 Color reset:", defaultColor);
      }
    });

/* ---------- LIQUOR ENGRAVING COLOR RESET ---------- */

document.querySelectorAll(
  ".customily_option.liquor-engraving-color"
).forEach(optionEl => {

  const optId = optionEl.getAttribute("opt-id");
  if (!optId) return;

  const defaultColor =
    window.customilyColorDefaults?.[optId];

  if (!defaultColor) {
    console.warn("❌ No engraving default found for", optId);
    return;
  }

  const radio = Array.from(
    optionEl.querySelectorAll("input[type='radio']")
  ).find(r => r.value.trim() === defaultColor);

  if (radio) {
    radio.click();
    console.log("🥃 Engraving reset:", defaultColor);
  }
});


    /* ---------- FONT RESET ---------- */

    setTimeout(() => {
      document.querySelectorAll(
        ".reset-font-suggestion, .reset-font"
      ).forEach(btn => btn.click());
    }, 150);

    console.log("✅ Reset completed");
  });

});



// OCCASION RESET SYSTEM (FINAL) Start
window.addEventListener("customily-options-loaded", function () {
/* ===============================
   OCCASION RESET SYSTEM (UPDATED)
================================= */

let OCCASION_INITIAL_STATE = null;

/* ---- Capture Defaults (ONLY ON FIRST LOAD) ---- */
function captureOccasionInitialState() {

  if (!window.currentProductType?.toLowerCase().includes("occasion")) return;

  if (OCCASION_INITIAL_STATE) return; // 🔥 Prevent overwrite

  const textFields = document.querySelectorAll(".customily_option.text-style input, .customily_option.text-style textarea");
  const colorFields = document.querySelectorAll(".customily_option.custom-design-color input[type='radio']:checked");

  if (!textFields.length) return;

  OCCASION_INITIAL_STATE = {
    text: {},
    colors: {}
  };

  textFields.forEach(input => {
    const optId = input.closest(".customily_option")?.getAttribute("opt-id");
    if (!optId) return;
    OCCASION_INITIAL_STATE.text[optId] = input.value;
  });

  colorFields.forEach(radio => {
    const optId = radio.closest(".customily_option")?.getAttribute("opt-id");
    if (!optId) return;
    OCCASION_INITIAL_STATE.colors[optId] = radio.value;
  });

  console.log("✅ Occasion defaults stored (once):", OCCASION_INITIAL_STATE);
}


/* ---- Inject Button ---- */
function injectOccasionResetButton() {

  if (!window.currentProductType?.toLowerCase().includes("occasion")) return;

  if (document.querySelector(".reset-suggestion-btn")) return;

  const allOptions = document.querySelectorAll(".customily_option");
  if (!allOptions.length) return;

  const lastOption = allOptions[allOptions.length - 1];

  const button = document.createElement("button");
  button.type = "button";
  button.className = "reset-suggestion-btn";
  button.innerHTML = "⟳ Reset to suggestion";

  lastOption.after(button);

  console.log("✅ Reset button inserted after last option");

}


/* ---- Initial Load ---- */
setTimeout(() => {
  injectOccasionResetButton();
  captureOccasionInitialState(); // 🔥 Only once
}, 1300);


/* ---- Variant Change (ONLY RE-INJECT BUTTON) ---- */
document.addEventListener("change", function (e) {

  if (e.target.matches('variant-selects input[type="radio"]')) {

    setTimeout(() => {
      injectOccasionResetButton(); // 🔥 No recapture
    }, 1000);

  }

});


/* ---- Reset Click ---- */
document.addEventListener("click", function (e) {

  if (!e.target.closest(".reset-suggestion-btn")) return;
  if (!window.currentProductType?.toLowerCase().includes("occasion")) return;

  if (!OCCASION_INITIAL_STATE) {
    console.log("❌ No stored default state");
    return;
  }

  console.log("♻️ RESET TRIGGERED");

  /* ---- TEXT RESET ---- */
  document.querySelectorAll(".customily_option.text-style input, .customily_option.text-style textarea")
    .forEach(input => {

      const optId = input.closest(".customily_option")?.getAttribute("opt-id");
      if (!optId) return;

      const defaultVal = OCCASION_INITIAL_STATE.text[optId];
      if (defaultVal === undefined) return;

      input.value = defaultVal;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

  /* ---- COLOR RESET ---- */
  Object.keys(OCCASION_INITIAL_STATE.colors).forEach(optId => {

    const defaultColor = OCCASION_INITIAL_STATE.colors[optId];
    const optionEl = document.querySelector(`.customily_option[opt-id="${optId}"]`);
    if (!optionEl) return;

    const radio = optionEl.querySelector(
      `input[type="radio"][value="${CSS.escape(defaultColor)}"]`
    );

    if (radio) radio.click();
  });

  /* ---- FONT RESET ---- */
  setTimeout(() => {
    document.querySelectorAll(".reset-font-suggestion, .reset-font")
      .forEach(btn => btn.click());
  }, 200);

  
});

});
// OCCASION RESET SYSTEM (FINAL) End



// sticky product image box
document.addEventListener("DOMContentLoaded", function () {

  /* RUN ONLY FOR CUSTOMILY / LIQUOR PRODUCTS */
  if (!window.isCustomilyProduct) return;

  if (!window.matchMedia("(max-width: 767px)").matches) return;

  const mediaWrapper = document.querySelector(".product__media-wrapper");
  if (!mediaWrapper) return;

  const formButtons = document.querySelector(".product-form__buttons");
  if (!formButtons) return;

  /* MINI PREVIEW */
  const miniPreview = document.createElement("div");
  miniPreview.className = "mini-preview";
  miniPreview.innerHTML = `
    <img class="mini-preview-img" src="" alt="Preview" />
    <span class="mini-preview-text">Click To Expand</span>
  `;
  document.body.appendChild(miniPreview);

  const miniPreviewImg = miniPreview.querySelector(".mini-preview-img");

  /* OVERLAY */
  const overlay = document.createElement("div");
  overlay.className = "preview-overlay";
  document.body.appendChild(overlay);

  /* CLOSE BUTTON */
  const closeBtn = document.createElement("div");
  closeBtn.className = "preview-close";
  closeBtn.innerHTML = "✕";
  mediaWrapper.appendChild(closeBtn);

  /* LIVE CANVAS UPDATE */
  function updateMiniPreview() {
    const clonedCanvas = document.getElementById("cloned-canvas");

    if (clonedCanvas && miniPreviewImg) {
      try {
        miniPreviewImg.src = clonedCanvas.toDataURL("image/png");
      } catch (e) {}
    }

    requestAnimationFrame(updateMiniPreview);
  }

  updateMiniPreview();

  /* SCROLL CONTROL */
  window.addEventListener("scroll", function () {

    const mediaRect = mediaWrapper.getBoundingClientRect();
    const formRect = formButtons.getBoundingClientRect();

    const imageAreaEnded = mediaRect.bottom < 0;
    const beforeFormButtons = formRect.top > 0;

    if (imageAreaEnded && beforeFormButtons) {
      miniPreview.classList.add("show");
    } else {
      miniPreview.classList.remove("show");
    }

  });

  /* OPEN POPUP */
  miniPreview.addEventListener("click", function () {
    mediaWrapper.classList.add("preview-expanded");
    overlay.classList.add("show");
    document.body.classList.add("no-scroll");
  });

  /* CLOSE POPUP */
  closeBtn.addEventListener("click", function () {
    mediaWrapper.classList.remove("preview-expanded");
    overlay.classList.remove("show");
    document.body.classList.remove("no-scroll");
  });

  overlay.addEventListener("click", function () {
    mediaWrapper.classList.remove("preview-expanded");
    overlay.classList.remove("show");
     document.body.classList.remove("no-scroll");
  });

});


// pdp checkbox popup code here
document.addEventListener("DOMContentLoaded", function () {
 
  window.addEventListener('customily-options-loaded', function () {
    setTimeout(() => {
      cloneCanvasToDivs([
        { divId: 'preview-canvas-popup', canvasId: 'cloned-canvas' }
      ]);
    }, 100);
  });

  function updateClonedCanvas(originalCanvas, clonedCanvas, clonedContext) {
    clonedCanvas.height = originalCanvas.height;
    clonedCanvas.width = originalCanvas.width;
    clonedContext.clearRect(0, 0, clonedCanvas.width, clonedCanvas.height);
    clonedContext.drawImage(originalCanvas, 0, 0, clonedCanvas.width, clonedCanvas.height);
    requestAnimationFrame(() => updateClonedCanvas(originalCanvas, clonedCanvas, clonedContext));
  }

  function cloneCanvasToDivs(items) {
    const originalCanvas = document.getElementById('preview-canvas');
    if (!originalCanvas) return;

    items.forEach(({ divId, canvasId }) => {
      const targetDiv = document.getElementById(divId);
      if (!targetDiv) return;

      const existing = targetDiv.querySelector(`#${canvasId}`);
      if (existing) existing.remove();

      const clonedCanvas = document.createElement('canvas');
      clonedCanvas.id = canvasId;
      clonedCanvas.width = originalCanvas.width;
      clonedCanvas.height = originalCanvas.height;

      const clonedContext = clonedCanvas.getContext('2d');

      targetDiv.innerHTML = '';
      const label = document.createElement('div');
      label.className = 'canvas-expand-label';
      label.textContent = 'Click To Expand';
      targetDiv.appendChild(clonedCanvas);
      targetDiv.appendChild(label);

      updateClonedCanvas(originalCanvas, clonedCanvas, clonedContext);
    });
  }

  // ✅ Popup wrapper setup
  const previewCanvasPopup = document.getElementById('preview-canvas-popup');

  const popupWrapper = document.createElement("div");
  popupWrapper.id = "canvas-popup-wrapper";
  popupWrapper.style.position = "fixed";
  popupWrapper.style.top = "0";
  popupWrapper.style.left = "0";
  popupWrapper.style.width = "100vw";
  popupWrapper.style.height = "100vh";
  popupWrapper.style.backgroundColor = "rgba(0, 0, 0, 0.4)";
  popupWrapper.style.display = "none";
  popupWrapper.style.alignItems = "center";
  popupWrapper.style.justifyContent = "center";
  popupWrapper.style.zIndex = "9999";
  popupWrapper.style.flexDirection = "column";
  popupWrapper.style.boxSizing = "border-box";

  // ✅ Container for canvas + close button
  const canvasContainer = document.createElement("div");
  canvasContainer.style.position = "relative";
  canvasContainer.style.display = "inline-block";

  const popupCanvas = document.createElement("canvas");
  popupCanvas.id = "popup-canvas";
  popupCanvas.style.maxWidth = "80vw";
  popupCanvas.style.maxHeight = "80vh";
  popupCanvas.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)";
  canvasContainer.appendChild(popupCanvas);

  const popupCloseBtn = document.createElement("button");
  popupCloseBtn.innerText = "X";
  popupCloseBtn.style.position = "absolute";
  popupCloseBtn.style.top = "10px";
  popupCloseBtn.style.right = "10px";
  popupCloseBtn.style.fontSize = "24px";
  popupCloseBtn.style.color = "white";
  popupCloseBtn.style.border = "none";
  popupCloseBtn.style.borderRadius = "50%";
  popupCloseBtn.style.cursor = "pointer";
  popupCloseBtn.style.zIndex = "10";
  canvasContainer.appendChild(popupCloseBtn);

  popupWrapper.appendChild(canvasContainer);
  document.body.appendChild(popupWrapper);

  if (previewCanvasPopup) {
    previewCanvasPopup.addEventListener("click", function () {
      const clonedCanvas = document.getElementById("cloned-canvas");
      if (!clonedCanvas) return;

      popupCanvas.width = clonedCanvas.width;
      popupCanvas.height = clonedCanvas.height;

      const ctx = popupCanvas.getContext("2d");
      ctx.clearRect(0, 0, popupCanvas.width, popupCanvas.height);
      ctx.drawImage(clonedCanvas, 0, 0);

      popupWrapper.style.display = "flex";
      // document.body.style.overflow = "hidden";
    });
  }

  popupCloseBtn.addEventListener("click", function () {
    popupWrapper.style.display = "none";
    document.body.style.overflow = "";
  });

  popupWrapper.addEventListener("click", function (e) {
    if (e.target === popupWrapper) {
      popupWrapper.style.display = "none";
      document.body.style.overflow = "";
    }
  });

  // ✅ BACKDROP + popup-active for preview-canvas-popup2
  const backdrop = document.createElement("div");
  backdrop.id = "popup-backdrop";
  backdrop.style.position = "fixed";
  backdrop.style.inset = "0";
  backdrop.style.background = "rgba(0, 0, 0, 0.4)";
  backdrop.style.zIndex = "9997";
  backdrop.style.display = "none";
  document.body.appendChild(backdrop);

  // if (previewCanvasPopup2 && mediaContainer) {
  //   previewCanvasPopup2.addEventListener('click', function () {
  //     mediaContainer.classList.add('popup-active');
  //     backdrop.style.display = "block";
  //     document.body.style.overflow = "hidden";
  //   });
  // }

  const closeBtn = document.querySelector('.customily-close-button');
  if (closeBtn && mediaContainer) {
    closeBtn.addEventListener('click', function () {
      mediaContainer.classList.remove('popup-active');
      backdrop.style.display = "none";
      document.body.style.overflow = "";
    });
  }

  backdrop.addEventListener("click", function () {
    mediaContainer.classList.remove('popup-active');
    backdrop.style.display = "none";
    document.body.style.overflow = "";
  });
});


//add to cart required msg code

(function () {

  if (typeof window.isCustomilyProduct === "undefined" || !window.isCustomilyProduct) {
    return;
  }

  const checkboxWrapper = document.querySelector(".main-preview-with-checkbox");
  const checkboxId = "agree_checkbox";
  const errorId = "checkbox-error";

  /* 🔍 Check if selected variant is None */
  function isVariantNone() {
  // Target only Choose Style group
  const styleFieldset = document.querySelector(
    ".product-form__input input[name='Choose Style']:checked"
  );

  if (!styleFieldset) return false;

  return styleFieldset.value.trim().toLowerCase() === "none";
}

  /* 👁 Show / Hide checkbox */
  function toggleCheckboxVisibility() {
    if (!checkboxWrapper) return;

    if (isVariantNone()) {
      checkboxWrapper.style.display = "none";
    } else {
      checkboxWrapper.style.display = "block";
    }
  }

  function showError() {
    const error = document.getElementById(errorId);
    if (error) error.style.display = "block";
  }

  function hideError() {
    const error = document.getElementById(errorId);
    if (error) error.style.display = "none";
  }

  /* Run on page load */
  document.addEventListener("DOMContentLoaded", toggleCheckboxVisibility);

  /* Run when variant changes */
  document.addEventListener("change", function (e) {
    if (e.target.matches(".product-form__input input[type='radio']")) {
      toggleCheckboxVisibility();
    }

    if (e.target.id === checkboxId && e.target.checked) {
      hideError();
    }
  });

  /* 🔥 FETCH INTERCEPT */
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = args[0];

    if (typeof url === "string" && url.includes("/cart/add")) {

      // If variant is None → allow add to cart directly
      if (isVariantNone()) {
        return originalFetch.apply(this, args);
      }

      const checkbox = document.getElementById(checkboxId);

      if (!checkbox || !checkbox.checked) {
        showError();
        console.warn("🛑 Add to cart blocked: checkbox not checked");
        return Promise.reject("Checkbox not checked");
      }
    }

    return originalFetch.apply(this, args);
  };

})();


//upload icon add code here
(function () {
  const ICON_URL =
    "https://cdn.shopify.com/s/files/1/0777/4601/2381/files/Frame_29.png?v=1767428094";

  function addUploadLabelAtTop() {
    document.querySelectorAll(".customily-file-input").forEach(wrapper => {
      // duplicate se bachao
      if (wrapper.querySelector(":scope > .upload-logo-inside")) return;

      const label = document.createElement("div");
      label.className = "upload-logo-inside";
      label.innerHTML = `
        <img src="${ICON_URL}" alt="Upload icon">
        <span>Upload your Image</span>
      `;

      // 🔥 CLICK → actual file input trigger
      label.addEventListener("click", () => {
        const fileInput = wrapper.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.click();
        }
      });

      // FIRST CHILD ke roop me add
      wrapper.insertBefore(label, wrapper.firstChild);
    });
  }

  // initial run
  addUploadLabelAtTop();

  // Customily re-render safe
  const observer = new MutationObserver(addUploadLabelAtTop);
  observer.observe(document.body, { childList: true, subtree: true });
})();


//filter accordion code here
function initMetaobjectFilters() {
  const currentHandle = window.currentCollectionHandle;

  document.querySelectorAll('.filter-group').forEach(group => {
    const toggleBtn = group.querySelector('.filter-toggle');
    const groupHandle = group.dataset.groupHandle;
    const items = group.querySelectorAll('.filter-item[data-handle]');

    // Bind toggle once
    if (toggleBtn && toggleBtn.dataset.bound !== 'true') {
      toggleBtn.dataset.bound = 'true';
      toggleBtn.addEventListener('click', e => {
        e.preventDefault();
        group.classList.toggle('open');
      });
    }

    // CASE 1: current collection IS the group
    if (groupHandle === currentHandle) {
      group.classList.add('open');
    }

    // CASE 2: current collection matches sub item
    items.forEach(item => {
      if (item.dataset.handle === currentHandle) {
        group.classList.add('open');
        item.classList.add('active'); // 🔥 checkbox checked
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initMetaobjectFilters);
document.addEventListener('shopify:section:load', initMetaobjectFilters);



//None variant padding 0
(function () {

  function applyPaddingLogic() {
    const selected = document.querySelector(
      'variant-selects input[name="Choose Style"]:checked'
    );

    const customilyBox = document.getElementById("cl_optionsapp");
    if (!selected || !customilyBox) return;

    if (selected.value === "None") {
      customilyBox.style.padding = "0px";
    } else {
      customilyBox.style.padding = "";
    }
  }

  // 🔥 Observe when Customily loads
  const observer = new MutationObserver(() => {
    if (document.getElementById("cl_optionsapp")) {
      applyPaddingLogic();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // 🔥 Listen variant change (works with Dawn AJAX)
  document.addEventListener("change", function (e) {
    if (e.target.matches('variant-selects input[name="Choose Style"]')) {
      setTimeout(applyPaddingLogic, 200);
    }
  });

})();


//cart image varinat none option code 
(function () {

  function isVariantNone() {
  const styleRadio = document.querySelector(
    ".variant-picker input[name='Choose Style']:checked"
  );

  return styleRadio && styleRadio.value.trim() === "None";
}

  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const url = args[0];

    if (typeof url === "string" && url.includes("/cart/add")) {

      if (isVariantNone()) {

        let options = args[1];

        if (options && options.body) {

          // Case 1: FormData
          if (options.body instanceof FormData) {
            options.body.delete("properties[_customily-thumb]");
          }

          // Case 2: JSON body
          if (typeof options.body === "string") {
            try {
              let parsed = JSON.parse(options.body);
              if (parsed.properties && parsed.properties["_customily-thumb"]) {
                delete parsed.properties["_customily-thumb"];
                options.body = JSON.stringify(parsed);
              }
            } catch (e) {
              console.warn("Body parse failed");
            }
          }

        }

        console.log("Customily thumb removed for None variant");
      }
    }

    return originalFetch.apply(this, args);
  };

})();




// home page slider for engraving
function initWineSlider() {
  if (!window.jQuery) return;

  var $slider = $('.tw-engraved-wine-slider');

  if ($slider.length && !$slider.hasClass('slick-initialized')) {
    $slider.slick({
      slidesToShow: 3.5,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      autoplay: false,
      dots: false,
      prevArrow: '<button type="button" class="left_arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#fff" fill="none"></path></svg></button>',
      nextArrow: '<button type="button" class="next_arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#fff" fill="none"></path></svg></button>',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2.5
          }
        },
        {
          breakpoint: 978,
          settings: {
            slidesToShow: 1.5
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.5
          }
        }
      ]
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(initWineSlider, 200);
});

document.addEventListener('shopify:section:load', function () {
  setTimeout(initWineSlider, 200);
});



// home page slider for testimonial

function initTestimonialSlider() {
  if (!window.jQuery || !$.fn.slick) return;

  var $slider = $('.testimonials-sectionh .slides-wrapper .swiper');

  if ($slider.length && !$slider.hasClass('slick-initialized')) {
    $slider.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      infinite: true,
      autoplay: false,
      dots: false,
      centerMode: true,
      easing: 'linear',
      speed: 500,
      centerPadding: '90px',
      prevArrow: '<button type="button" class="left_arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#fff" fill="none"></path></svg></button>',
      nextArrow: '<button type="button" class="next_arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#fff" fill="none"></path></svg></button>',
      responsive: [
        {
          breakpoint: 1331,
          settings: {
            slidesToShow: 3,
            centerPadding: '50px'
          }
        },
        {
          breakpoint: 978,
          settings: {
            slidesToShow: 2,
            centerPadding: '50px'
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerPadding: '50px'
          }
        }
      ]
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(initTestimonialSlider, 200);
});

document.addEventListener('shopify:section:load', function () {
  setTimeout(initTestimonialSlider, 200);
});

// Fix missing alt text on Customily swatch images
(function () {
  if (!window.isCustomilyProduct) return;

  function fixCustomilyAlts() {
    document.querySelectorAll('img[src*="cdn.customily.com"]:not([alt])').forEach(img => {
      // Try dropdown container first
      const container = img.closest('.csh-dropdown-input-container');
      const dropdownLabel = container?.querySelector('.csh-dropdown-label');

      if (dropdownLabel) {
        img.setAttribute('alt', dropdownLabel.textContent.trim());
        return;
      }

      // Try swatch/radio label structure
      const swatchLabel = img.closest('label');
      const swatchInput = swatchLabel?.control ||
        document.getElementById(swatchLabel?.getAttribute('for'));

      if (swatchInput?.value) {
        img.setAttribute('alt', swatchInput.value.trim());
        return;
      }

      // Generic fallback
      img.setAttribute('alt', 'Design option');
    });
  }

  const observer = new MutationObserver(fixCustomilyAlts);
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', fixCustomilyAlts);
})();